var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootfolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27338 16.7983V5.20166H10.7669L12.6223 7.83685H20.9711V16.7983C20.9711 17.9029 20.0757 18.7983 18.9711 18.7983H6.27338C5.16881 18.7983 4.27338 17.9029 4.27338 16.7983Z",
    stroke: "#F1F7FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4274 10.7556C12.4825 10.5611 12.7585 10.5619 12.8126 10.7567L13.3026 12.5226C13.3226 12.5947 13.3812 12.6496 13.4544 12.6649L15.2905 13.0494C15.4997 13.0932 15.5035 13.3905 15.2955 13.4398L13.4492 13.877C13.3788 13.8936 13.3229 13.947 13.303 14.0166L12.8151 15.7216C12.7597 15.9151 12.4853 15.9148 12.4304 15.7211L11.9265 13.9426C11.9062 13.8711 11.848 13.8168 11.7752 13.8014L10.0054 13.4289C9.79363 13.3843 9.79363 13.082 10.0054 13.0374L11.7752 12.6649C11.848 12.6495 11.9062 12.5952 11.9265 12.5237L12.4274 10.7556Z",
    fill: "#F1F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootfolder);
export default __webpack_public_path__ + "static/media/rootfolder.77b8ddfc916f6a74cfc4769cb4a627b3.svg";
export { ForwardRef as ReactComponent };